var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "teaser-content cell" },
    [
      _vm.groupitem.link && _vm.groupitem.link.url
        ? _c(
            "div",
            { staticClass: "title" },
            [
              !_vm.groupitem.link.title
                ? _c(
                    "generic-link",
                    { attrs: { href: _vm.groupitem.link.url } },
                    [
                      _vm.groupitem.title
                        ? _c("h3", { staticClass: "group-title" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.groupitem.title) +
                                "\n      "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm.groupitem.title
                ? _c("h3", { staticClass: "group-title" }, [
                    _vm._v("\n      " + _vm._s(_vm.groupitem.title) + "\n    "),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _c("div", { staticClass: "title" }, [
            _c("h3", [_vm._v(_vm._s(_vm.groupitem.title))]),
          ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "description",
        domProps: { innerHTML: _vm._s(_vm.groupitem.body) },
      }),
      _vm._v(" "),
      _vm.groupitem.link && _vm.groupitem.link.url && _vm.groupitem.link.title
        ? _c("generic-link", { attrs: { href: _vm.groupitem.link.url } }, [
            _vm._v("\n    " + _vm._s(_vm.groupitem.link.title) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }